
export const apiService = {


  getLeadData: async function(campaignId, dateFrom, dateTo, interval)
  {
    const url = "/vcg.customercenter/leadkampagnen/getLeadData";

    const params = new URLSearchParams({
      "campaignId": campaignId,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
      "interval": interval
    });

    try
    {
      const response = await fetch(url + `?${params}`);

      if (!response.ok)
      {
        throw new Error(`Response status: ${response.status}`);
      }
      const json = await response.json();
      return (json);
    }
    catch (error)
    {
      console.error(error.message);
    }
  },
  getPositionData: async function(positionId, dateFrom, dateTo, interval)
  {
    const url = "/vcg.customercenter/leadkampagnen/updatelinechart";

    const params = new URLSearchParams({
      "positionId": positionId,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
      "interval": interval
    });

    try
    {
      const response = await fetch(url + `?${params}`);

      if (!response.ok)
      {
        throw new Error(`Response status: ${response.status}`);
      }

      const json = await response.json();
      return (json);
    }
    catch (error)
    {
      console.error(error.message);
    }
  }
};






